"use strict";
exports.__esModule = true;
exports.PinTypes = void 0;
var PinTypes;
(function (PinTypes) {
    PinTypes[PinTypes["DOT"] = 0] = "DOT";
    PinTypes[PinTypes["BUBBLE"] = 1] = "BUBBLE";
    PinTypes[PinTypes["BUBBLE_LEG"] = 2] = "BUBBLE_LEG";
    PinTypes[PinTypes["CALLOUT"] = 3] = "CALLOUT";
})(PinTypes = exports.PinTypes || (exports.PinTypes = {}));
